module.exports = __webpack_public_path__ + "img/hk.5eb0c611.svg";